import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

/**
 * Subscribe to an event (`subscribed === false`) or unsubscribe from an event
 * (`subscribed === true`).
 * Backend: POST /api/user/subscriptEvent/subscriptEvent
 * Backend: PUT /api/user/subscriptEvent/unsubscriptEvent
 */
export const SubscribeOrNotAPI = async (
  subscribed: boolean,
  event_id: string,
): Promise<ServiceResponse> => {
  const { user } = store.getState().auth as any;
  try {
    const resp = subscribed
      ? await service.call("PUT", "api/user/subscriptEvent/unsubscriptEvent", {
          user_id: user?.id,
          event_id,
        })
      : await service.call("POST", "api/user/subscriptEvent/subscriptEvent", {
          user_id: user?.id,
          event_id,
        });
    return resp;
  } catch (err) {
    console.error(`SubscribeOrNotAPI ${err}`);
    return { status: -1 };
  }
};

/**
 * Check whether the current student is subscribed to an event. The backend
 * answers `status: 0` with the record when subscribed and `status: 1` with
 * `null` when not.
 * Backend: GET /api/user/subscriptEvent/checkSubscription
 */
export const CheckSubscriptEventAPI = async (
  event_id: string,
): Promise<ServiceResponse<unknown>> => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "GET",
      "api/user/subscriptEvent/checkSubscription",
      {
        user_id: user?.id,
        event_id,
      },
    );
    return resp;
  } catch (err) {
    console.error(`CheckSubscriptEventAPI ${err}`);
    return { status: -1 };
  }
};
